import React from "react";
import IosArrowLeft from "react-icons/lib/io/android-arrow-back";

export default function LeftIcon(props) {
    return <IosArrowLeft {...props} />;
}
